
import { ref } from "vue"
import Navbar from '@/components/NavBar.vue'
import PunishmentEntriesList from "@/components/PunishmentEntriesList.vue"
import PunishmentEntry from "@/components/PunishmentEntry.vue"
import Container from "@/components/SpicyContainer.vue"
import { api, toast } from '@/util/util'
import {VBtn} from "vuetify/components";

const page = ref(0)
const punishments = ref([])
const hasNext = ref(false)
const disableFetchMoreButton = ref(false)

const highlight = ref([])

export default {
  components: {
    Container,
    PunishmentEntry,
    PunishmentEntriesList,
    Navbar,
    VBtn,
  },
  methods: {
    fetchMore() {
      if (!hasNext.value) return
      disableFetchMoreButton.value = true
      fetch(api(`/punishments/list?page=${++page.value}`), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-SpicyAzisaBan-Session': localStorage.getItem("spicyazisaban_session"),
        },
        credentials: 'include',
      }).then(res => res.json()).then(res => {
        if (res['error']) {
          return
        }
        const data = res['data']
        console.log(res)
        hasNext.value = res['hasNext']
        punishments.value = punishments.value.concat(data)
      }).finally(() => disableFetchMoreButton.value = false)
    },
    redirectTo(id: number) {
      location.href = `/punishments/view?id=${id}`
    },
  },
  setup() {
    fetch(api(`/punishments/list?page=${page.value}`), {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-SpicyAzisaBan-Session': localStorage.getItem("spicyazisaban_session"),
      },
      credentials: 'include',
    }).then(res => res.json()).then(res => {
      if (res['error']) {
        return
      }
      const data = res['data']
      console.log(res)
      hasNext.value = res['hasNext']
      punishments.value = punishments.value.concat(data)
    })
    return {
      page,
      punishments,
      hasNext,
      disableFetchMoreButton,
      highlight,
    }
  },
  mounted() {
    const params = new URLSearchParams(location.search)
    if (params.get('error')) {
      const e = params.get('error')
      if (e === 'not_logged_in') {
        toast('エラー: ログインしてません。')
      } else if (e === 'missing_permissions') {
        toast('エラー: 権限がありません。')
      } else if (e === 'discord_not_linked') {
        toast('エラー: Discordアカウントは連携されていません。')
      } else {
        toast('エラー: ' + e)
      }
    }
  },
}

const checkHash = () => {
  const match = location.href.match(/(.*?)#(.*)/)
  if (match && match[2]) {
    highlight.value = match[2].split(',').flatMap(s => {
      const match2 = s.match(/(\d+)-(\d+)/)
      if (match2) {
        const arr = []
        const i1 = parseInt(match2[1])
        const i2 = parseInt(match2[2])
        if (i1 <= i2) {
          for (let i = i1; i <= i2; i++) {
            arr.push(i)
          }
        } else {
          for (let i = i2; i <= i1; i++) {
            arr.push(i)
          }
        }
        return arr
      } else {
        return [ parseInt(s, 10) ]
      }
    }).filter(i => i > 0)
  }
}

checkHash()

addEventListener('hashchange', () => checkHash())
